/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum SolutionMemberType {
    Ticket = 1,
    Mission = 2,
    Issue = 3,
}
